import { Observable, observe, Scope } from 'wdc-cube'
import { AnaliseRow } from '../analise.types'

@Observable
export class AnaliseSelectScope extends Scope {
    @observe() idSelected = 0 as number
    @observe() nomeAnaliseInputRef = '' as string

    @observe() analises = [] as AnaliseRow[]

    onClose = Scope.ASYNC_ACTION
    onFind = Scope.ASYNC_ACTION
    onSelect = Scope.ASYNC_ACTION
}

export default AnaliseSelectScope
